module.exports = __webpack_public_path__ + "img/bmcl_gallery10.22aeb680.jpg";